<script>

export default {
    name: 'ModalVisualizarDesenho',
    props: [
        "usuarioStore",
        "dado",
        "visualizandoDado",
        "controlesDesativados"
    ],
    emits: [
        "update:alteraDado",
        "update:alteraVisualizandoDado"
    ],
    computed: {
        statusColor() {
            switch(this.dado?.status) {
                case 'Elaborado': return 'success';
                case 'Cancelado': return 'error';
                case 'Elaboração': return 'warning';
                default: return 'grey';
            }
        }
    },
    methods: {
        alteraDado(update) {
            this.$emit('update:alteraDado', update);
        },
        alteraVisualizandoDado(update) {
            this.$emit('update:alteraVisualizandoDado', update);
        },
        fecharModal() {
            this.alteraVisualizandoDado({ visualizandoDado: false, dado: {} });
        }
    }
};

</script>

<template>
    <v-dialog
        :value="visualizandoDado"
        @input="fecharModal"
        max-width="900px"
        :disabled="controlesDesativados"
    >
        <v-card>
            <v-card-title class="primary white--text">
                <v-icon left color="white">mdi-eye</v-icon>
                Visualizar Desenho
            </v-card-title>

            <v-card-text class="pt-6">
                <!-- Seção: Informações Básicas -->
                <div class="mb-4">
                    <h3 class="subtitle-1 mb-2">Informações Básicas</h3>
                    <v-divider class="mb-4"></v-divider>

                    <v-row>
                        <v-col cols="12" md="3">
                            <div class="info-field">
                                <label>ID</label>
                                <p>{{ dado.code || '-' }}</p>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-field">
                                <label>Status</label>
                                <p>
                                    <v-chip 
                                        :color="statusColor"
                                        small
                                        dark
                                    >
                                        {{ dado.status || 'Elaboração' }}
                                    </v-chip>
                                </p>
                            </div>
                        </v-col>

                        <v-col cols="12" md="6">
                            <div class="info-field">
                                <label>Número do Desenho</label>
                                <p class="font-weight-bold primary--text">{{ dado.sequential || '-' }}</p>
                            </div>
                        </v-col>
                    </v-row>
                </div>

                <!-- Seção: Dados da Numeração -->
                <div class="mb-4">
                    <h3 class="subtitle-1 mb-2">Dados da Numeração</h3>
                    <v-divider class="mb-4"></v-divider>

                    <v-row>
                        <v-col cols="12" md="6">
                            <div class="info-field">
                                <label>Código de Equipamento</label>
                                <p>{{ dado.CodeEqipment || '-' }}</p>
                            </div>
                        </v-col>

                        <v-col cols="12" md="6">
                            <div class="info-field">
                                <label>Tipo de Equipamento</label>
                                <p>{{ dado.typeEquipment || '-' }}</p>
                            </div>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="6">
                            <div class="info-field">
                                <label>Modelo ou Tamanho</label>
                                <p>{{ dado.sizeDocument || '-' }}</p>
                            </div>
                        </v-col>

                        <v-col cols="12" md="6">
                            <div class="info-field">
                                <label>Parte do Equipamento</label>
                                <p>{{ dado.pieceEquipment || '-' }}</p>
                            </div>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="6">
                            <div class="info-field">
                                <label>Destino do Desenho</label>
                                <p>{{ dado.destinyDsenho || '-' }}</p>
                            </div>
                        </v-col>

                        <v-col cols="12" md="6">
                            <div class="info-field">
                                <label>Formato do Desenho</label>
                                <p>{{ dado.fomatDocument || '-' }}</p>
                            </div>
                        </v-col>
                    </v-row>
                </div>

                <!-- Seção: Informações Adicionais -->
                <div class="mb-4">
                    <h3 class="subtitle-1 mb-2">Informações Adicionais</h3>
                    <v-divider class="mb-4"></v-divider>

                    <v-row>
                        <v-col cols="12">
                            <div class="info-field">
                                <label>Título / Descrição</label>
                                <p>{{ dado.descriptionDes || '-' }}</p>
                            </div>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="6">
                            <div class="info-field">
                                <label>Número do Cliente</label>
                                <p>{{ dado.numeroCliente || '-' }}</p>
                            </div>
                        </v-col>

                        <v-col cols="12" md="6">
                            <div class="info-field">
                                <label>Link do Arquivo</label>
                                <p>
                                    <a v-if="dado.anexo" :href="dado.anexo" target="_blank">
                                        {{ dado.anexo }}
                                    </a>
                                    <span v-else>-</span>
                                </p>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>

            <v-card-actions class="pa-4 grey lighten-4">
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    @click="fecharModal"
                >
                    Fechar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped>
.subtitle-1 {
    font-weight: 600;
    color: #333;
}

.info-field {
    margin-bottom: 8px;
}

.info-field label {
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: #666;
    margin-bottom: 4px;
    text-transform: uppercase;
}

.info-field p {
    font-size: 14px;
    color: #333;
    margin: 0;
}

.info-field a {
    color: #1976d2;
    text-decoration: none;
}

.info-field a:hover {
    text-decoration: underline;
}
</style>
